/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
        wishlists: 'plus'
    }, window.boostSDAppConfig.integration || {});
}
// Start Boost 191486
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
    registry.useComponentPlugin('ShowLimitList', {
        name: 'Custom itemPerPageOptions',
        enabled: true,
        apply: () => ({
            props: (props) => {
                props.itemPerPageOptions = [24, 48, 70];
                return props;
            }
        }),
    });
    registry.useModulePlugin('FilterAPI', {
        name: 'Extra params filter in collection page',
        apply(builder) {
            builder.on('beforeMethodCall', 'get', (payload) => {
                try {
                    if (payload?.args) {
                        // Find price param
                        const priceParam = payload.args.filter(function(e) {
                            return e?.pf_p_price;
                        })
                        if (typeof priceParam[0] !== 'undefined' && priceParam[0]['pf_p_price'].length > 1) {
                            const sortIndex = payload.args.findIndex(function(e) {
                                return e?.sort;
                            })
                            if (sortIndex > -1) {
                                payload.args[sortIndex]['sort'] = 'price-ascending';
                            }
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            });
        },
    });
});
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FilterTree', {
            name: 'FilterTree - Custom hide filterTree when not filter options',
            apply: () => ({
                afterInit(element) {
                    setTimeout(() => {
                        var filters = document.querySelector('.boost-sd__filter-tree-vertical-option-list');
                        if (!filters) filters = document.querySelector('.boost-sd__filter-tree-vertical-option-list');
                        if (filters != null && filters.children.length == 0) {
                            document.querySelector(".boost-sd-layout").classList.add('boost-sd__filter-tree-wrapper-hide');
                            if (document.querySelector(".boost-sd__filter-tree-toggle-button") != null)
                                document.querySelector(".boost-sd__filter-tree-toggle-button").classList.add('boost-sd__filter-tree-wrapper-mobile-hide');
                        }
                    }, 1500);
                },
            }),
        });
    }
]);
const updateProductItem = (componentRegistry) => {
    console.log(componentRegistry);
    componentRegistry.useComponentPlugin('ProductItem', {
        name: 'Hide $0 products',
        enabled: true,
        apply: () => ({
            afterRender(element) {
                try {
                    let productData = element.getParams().props.product;
                    let productId = productData.id;
                    if (productData?.split_product) {
                        productId = productData.variant_id;
                    }
                    let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                    // let productDataLink = productItem.querySelector('.boost-sd__product-link-image').getAttribute("href");
                    let productDataLink = productItem.querySelector('.boost-sd__product-link:not(.boost-sd__product-link-image)').getAttribute("href");
                    // log the productData variable
                    // console.log(productData);
                    // console.log(productItem);
                    img_list = "";
                    productData.images_info.forEach((imageDetail, index) => {
                        img_src = imageDetail.src;
                        img_list = img_list + `<span class="slider_item"><a href="` + productDataLink + `"><img id="product-image-` + productData.id + `-` + index + `" class="boost-sd__product-image-img boost-sd__product-image-img--main" src="` + img_src + `" srcset="` + img_src + `&amp;width=200 200w, ` + img_src + `&amp;width=300 300w, ` + img_src + `&amp;width=400 400w, ` + img_src + `&amp;width=500 500w, ` + img_src + `&amp;width=600 600w, ` + img_src + `&amp;width=700 700w, ` + img_src + `&amp;width=800 800w, ` + img_src + `&amp;width=900 900w, ` + img_src + `&amp;width=1000 1000w, ` + img_src + `&amp;width=1100 1100w, ` + img_src + `&amp;width=1200 1200w, ` + img_src + `&amp;width=1600 1600w" fetchpriority="high" decoding="async" loading="eager"></a></span>`;
                    });
                    if (productItem) {
                        productItem.querySelector('.boost-sd__product-image').innerHTML = img_list
                        productItem.querySelector('.boost-sd__product-link-image').setAttribute("href", "javascript:void(0)");
                        if (productData.price_min < 1) productItem.querySelector('.boost-sd__product-price').innerHTML = '<div class="boost-sd__product-price-wrapper"><span class="boost-sd__product-price-content boost-sd__product-price-content--text-align-left"><span class="boost-sd__format-currency" style="color: rgb(34, 34, 34);"><span class=""></span></span></span></div>';
                    }
                } catch (e) {
                    console.warn(e);
                }
            }
        }),
    });
    componentRegistry.useComponentPlugin('ProductListPagination', {
        name: 'addShowlimit',
        enabled: true,
        apply: () => ({
            props(props) {
                props.hasShowLimitList = true;
                return props;
            }
        }),
    });
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem]);
// End Boost 191486
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FilterOption', {
            name: 'FilterOption - Customize sorting',
            apply: () => ({
                props: (props) => {
                    // can custom for any Filter Option check props to customize for special FilterOption
                    let ids = ["pf_m_::custom::jewelry_size"];
                    if (ids.includes(props.option.filterOptionId)) {
                        props.customizeSorting = (values) => {
                            // change logic sorting
                            let newValues = values.map(e => {
                                e.new_key = e.key.replace(/^\D+/g, '');
                                return e
                            })
                            return values.sort((a, b) => a.new_key - b.new_key);
                        }
                    }
                    return props;
                },
            }),
        });
    }
]);
const customize = {
    updateBtns: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Modify Product Buttons',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }
                        let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                        var sku = '<span class="boost-sd-sku">' + element.getParams().props.product.skus + '</span>';
                        if (productItem) {
                            productItem.querySelector('.boost-sd__product-title').innerHTML = element.getParams().props.product.title + '</br>' + sku
                        }
                    } catch (e) {
                        console.warn(e);
                    }
                }
            }),
        });
    }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateBtns]);
// PaginationNumber
const updateProductSlider = (componentRegistry) => {
    console.log(componentRegistry);
    componentRegistry.useComponentPlugin('PaginationRange', {
        name: 'Slider',
        enabled: true,
        apply: () => ({
            afterRender(element) {
                try {
                    setTimeout(function() {
                        $('body .boost-sd__product-image').slick({
                            infinite: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="_fc6c973f _990c0c5c _bc501c6d" data-tn="arrow-left" viewBox="-8.5 0 32 32"><path d="M14 32c-.3 0-.6-.1-.8-.3l-13-15c-.3-.4-.3-.9 0-1.3l13-15c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4L2.3 16l12.4 14.3c.4.4.3 1-.1 1.4-.2.2-.4.3-.6.3z"></path></svg></button>',
                            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="_fc6c973f _990c0c5c _7c00b29b" data-tn="arrow-right" viewBox="-8.5 0 32 32"><path d="M1 0c.3 0 .6.1.8.3l13 15c.3.4.3.9 0 1.3l-13 15c-.4.4-1 .5-1.4.1-.4-.4-.5-1-.1-1.4L12.6 16 .2 1.7C-.2 1.3-.1.7.3.3.5.1.8 0 1 0z"></path></svg></button>'
                        });
                    }, 3000);
                } catch (e) {
                    console.warn(e);
                }
            }
        }),
    });
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductSlider]);
document.addEventListener('click', function(event) {
    let productItem = event.target.closest('.boost-sd__product-item');
    if (productItem && event.target.nodeName !== "BUTTON" && !event.target.closest('.boost-sd__popup-select-option')) {
        let productLink = productItem.querySelector('.boost-sd__product-link:not(.boost-sd__product-link-image)');
        if (productLink) {
            let href = productLink.getAttribute("href");
            if (href) {
                window.location.href = href;
            }
        }
    }
});